var addListener = (function() {
  if (window.addEventListener) {
    return function(target, name, handler) {
      target.addEventListener(name, handler, false);
    };
  } else {
    return function(target, name, handler) {
      target.attachEvent('on' + name, handler);
    };
  }
})();
var removeListener = (function() {
  if (window.removeEventListener) {
    return function(target, name, handler) {
      target.removeEventListener(name, handler);
    };
  } else {
    return function(target, name, handler) {
      target.detachEvent('on' + name, handler);
    };
  }
})();

export default {
  attach(name, handler, targetDom) {
    addListener(targetDom || window, name, handler);
  },
  detach(name, handler, targetDom) {
    removeListener(targetDom || window, name, handler);
  }
};



// WEBPACK FOOTER //
// ./src/common/utils/EventUtils.js